import { cn } from 'utils/helpers'
import styles from './grid.module.scss'

export default function Grid({ items, component, props, limit, perLine }) {
    const Component = component
    return (
        <div className={cn(styles.grid, styles[`grid${perLine}`])}>
            {items.map((item, k) => {
                if (limit && k > limit) return null
                return <Component key={item.slug} {...props} hit={{ ...item, __position: k + 1 }} />
            })}
        </div>
    )
}
